<i18n
  src="@/locales/views/agro_exporter/quality_control/crop_field/list_templates.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/crop_field.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/quality_template.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="ae_quality_control_crop_field_list_crop_fields_path"
    :params="{
      agro_exporter_id: agro_exporter_id,
      producer_id: producer_id
    }"
  ></go-back-link>

  <bread-crumbs
    :labels="[
      module_name,
      crop_field?.code
    ]"
  ></bread-crumbs>

  <template v-if="load_data_general">
    <crop-field-info :crop_field="crop_field"></crop-field-info>

    <h1 class="page-title mt-8">
      <i class="fa-solid fa-box-check"></i><span class="space-icon"></span>
      {{ $t("labels.title") }}
    </h1>

    <div class="mt-8 flex flex-col">
      <div class="bg-white shadow overflow-hidden sm:rounded-md">
        <ul role="list" class="divide-y divide-slate-200">
          <li
            v-for="template in producer_quality_template"
            :key="template.id"
          >
            <div
              class="block hover:bg-slate-50 cursor-pointer"
              @click="goToListQualityInspects(template)"
            >
              <div class="px-4 py-4 sm:px-6">
                <div class="flex items-center justify-between">
                  <p class="text-sm font-medium text-gray-900 truncate">
                    {{ template.name }}
                  </p>
                  <div class="ml-2 flex-shrink-0 flex">
                    <a class="link invisible sm:visible">
                      <i class="fa-solid fa-pen"></i>
                      <span class="space-icon"></span>
                      {{ $t("labels.manage_link") }}
                    </a>
                  </div>
                </div>

                <div class="mt-2 sm:flex sm:justify-between">
                  <div class="sm:flex">
                    <p class="flex items-center text-sm text-gray-500">
                      <i
                        class="fa-solid fa-crate-apple flex-shrink-0"
                        aria-hidden="true"
                      />
                      <span class="space-icon"></span>
                      {{ template.number_inspects }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/quality_control/crop_field/list_templates.js";
import CropFieldInfo from "@/components/views/agro_exporter/quality_control/crop_field/CropFieldInfo.vue";

export default {
  components: { CropFieldInfo },
  name: "ListTemplates",

  props: ["agro_exporter_id", "producer_id", "crop_field_id"],
  data() {
    return {
      load_data_general: false,
      crop_field: {},
      producer_quality_template: []
    };
  },
  methods: {
    fetchData: async function () {
      await this.fetchCropField();
      await this.fetchTemplates();
      this.load_data_general = true;
    },
    fetchCropField: async function () {
      let response = await Requester.fetchCropField(
        this.agro_exporter_id,
        this.crop_field_id
      );
      this.crop_field = response.data;
    },
    fetchTemplates: async function () {
      let response = await Requester.fetchTemplates(
        this.agro_exporter_id,
        this.crop_field_id
      );
      this.producer_quality_template = response.data;
    },
    goToListQualityInspects: function (template) {
      this.$router.push({
        name: "ae_quality_control_crop_field_list_quality_inspects_path",
        params: {
          agro_exporter_id: this.agro_exporter_id,
          producer_id: this.producer_id,
          crop_field_id: this.crop_field_id,
          exporter_process_quality_template_id: template.id
        }
      });
    },
    goToTemplateGraph: function (producer_quality_template) {
      this.$router.push({
        name: "ae_quality_control_crop_field_crop_fields_inspect_graphs_path",
        params: {
          agro_exporter_id: this.agro_exporter_id,
          producer_id: this.producer_id,
          producer_quality_template_id:
            producer_quality_template.id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => {
        this.fetchData();
      })
    );
  }
};
</script>
